export default __webpack_public_path__ + "static/media/blockIcon.38985ff4.svg";